module.exports = __webpack_public_path__ + "img/symbol_10_x20.44305c58.png";